import React from 'react'
import './privacypolicy.css'
import Footer from '../footer/Footer'
import Nav from '../Nav/Nav'

const Privacypolicy = () => {
    return (
        <>
            <Nav />
            <section id='aboutUs' className='banner_area'>
                <div className="banner_inner d-flex align-items-center">
                    <div className="overlay"></div>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <div className="banner_content text-center">
                                    <h2>Privacy & Policy</h2>
                                    <div className="page_link">
                                        <a href="/">Home</a>
                                        <a href="/privacypolicy">Privacy Policy</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container section_gap">
                <div className="main_title">
                    <h2 className='text-center'>Privacy Policy</h2>
                    <p>Last updated: March 1st, 2025</p>
                </div>

                <h4>Introduction</h4>
                <p>
                    This Privacy Policy describes how and its (collectively "CONQUER ELEARNING PRIVATE LIMITED", "we", "our", "us") collect, use, share, protect or otherwise process your information/personal data through (hereinafter referred to as Platform).
                </p>
                <p>
                    Please note that you may be able to browse certain sections of the Platform without registering with us. We do not offer any product/service under this Platform outside India and your personal data will primarily be stored and processed in India.
                </p>
                <p>
                    By visiting this Platform, providing your information or availing any product/service offered on the Platform, you expressly agree to be bound by the terms and conditions of this Privacy Policy, the Terms of Use and the applicable service/product terms and conditions, and agree to be governed by the laws of India including but not limited to the laws applicable to data protection and privacy. If you do not agree please do not use or access our Platform.
                </p>

                <h4>Collection</h4>
                <p>
                    We collect your personal data when you use our Platform, services or otherwise interact with us during the course of our relationship. Some of the information that we may collect includes but is not limited to personal data/information provided to us during signup/registering or using our Platform such as name, date of birth, address, telephone/mobile number, email ID and/or any such information shared as proof of identity or address.
                </p>
                <p>
                    Some of the sensitive personal data may be collected with your consent, such as your bank account or credit/debit card or other payment instrument information or biometric information such as your facial features or physiological information (in order to enable use of certain features when opted for, available on the Platform) — all of the above being in accordance with applicable law(s).
                </p>
                <p>
                    You always have the option to not provide information, by choosing not to use a particular service or feature on the Platform. We may track your behaviour, preferences, and other information that you choose to provide on our Platform. This information is compiled and analyzed on an aggregated basis. We will also collect your information related to your transactions on the Platform and such third-party business partner platforms.
                </p>
                <p>
                    When such a third-party business partner collects your personal data directly from you, you will be governed by their privacy policies. We shall not be responsible for the third-party business partner’s privacy practices or the content of their privacy policies, and we request you to read their privacy policies prior to disclosing any information.
                </p>
                <p>
                    If you receive an email or a call from a person/association claiming to be seeking any personal data like debit/credit card PIN, net-banking or mobile banking password, we request you to <strong>never provide such information</strong>.
                </p>
            </div>

            <Footer />
        </>
    )
}

export default Privacypolicy
